import {
  ValidatorFn,
  AbstractControl,
  FormGroup,
  FormArray,
  FormControl,
  FormRecord,
} from '@angular/forms';

export const MULTILANGUAGE_ERROR_KEY = 'invalidMultilanguages';

export function multilanguageErrors(languages: string[]): ValidatorFn {
  return (form: AbstractControl) => {
    const invalidLanguages = new Set(findMultilanguageErrors(form, languages));
    return invalidLanguages.size
      ? { [MULTILANGUAGE_ERROR_KEY]: [...invalidLanguages] }
      : null;
  };
}

function findMultilanguageErrors(
  control: AbstractControl,
  languages: string[],
  name?: string,
) {
  const errors: string[] = [];
  if (control instanceof FormGroup || control instanceof FormRecord) {
    const controls = control.controls;
    Object.entries(controls).forEach(
      ([key, ctrl]: [string, AbstractControl]) => {
        errors.push(...findMultilanguageErrors(ctrl, languages, key));
      },
    );
  } else if (control instanceof FormArray) {
    control.controls.forEach((ctrl) => {
      errors.push(...findMultilanguageErrors(ctrl, languages));
    });
  } else if (control instanceof FormControl && control.errors) {
    if (name && languages.includes(name)) {
      errors.push(name);
    } else {
      const multilanguageErrors = (control.getError(MULTILANGUAGE_ERROR_KEY) ??
        []) as string[];
      errors.push(...multilanguageErrors);
    }
  }
  return errors;
}
